import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetInstallationsEnabledModulesServerReqData } from "./GetInstallationsEnabledModulesCommand";

const ENDPOINT = "/license/installations_enabled_modules_csv";

export class DownloadInstallationsEnabledModulesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(params: GetInstallationsEnabledModulesServerReqData, exportType: string) {
        super();
        this.params = { exportType, ...params };
        this.responseType = "text";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        console.debug("DownloadInstallationsEnabledModulesCommand.execute()");
        return await this.executeCommand(this.params);
    }
}
